module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_photosynthesis_1-d0c6b879aab623a29046a7d7a61a15b7.jpg";